/**
 * Ilustração do refino visual (handoff 23/09/2026): 15 desenhos, cada um com
 * versão clara e escura, escolhida pelo tema do app.
 *
 * Os SVGs são importados (não servidos de `public/`): abaixo de 4 KB o Vite
 * os embute no bundle como data URI, e o bundle já está no precache do
 * Service Worker — o estado vazio continua ilustrado offline, sem mexer na
 * configuração do SW. O metadado C2PA dos arquivos originais (≈ 90% do
 * tamanho) foi retirado; o desenho é o mesmo.
 */
import { useNomeDoTema } from '../theme/ThemeProvider';

const CLARO = import.meta.glob<string>('./ilustracoes/*.svg', { eager: true, import: 'default' });
const ESCURO = import.meta.glob<string>('./ilustracoes/escuro/*.svg', { eager: true, import: 'default' });

export const ILUSTRACOES = [
  'atividade',
  'bagagem',
  'carro',
  'concluido',
  'despesa',
  'diaLivre',
  'emergencia',
  'enquetes',
  'grupo',
  'mapa',
  'memorias',
  'passaporte',
  'ranking',
  'sugestao',
  'vazioViagens',
] as const;

export type NomeIlustracao = (typeof ILUSTRACOES)[number];

export function srcDaIlustracao(nome: NomeIlustracao, tema: 'light' | 'dark'): string {
  const escura = ESCURO[`./ilustracoes/escuro/${nome}.svg`];
  const clara = CLARO[`./ilustracoes/${nome}.svg`];
  return (tema === 'dark' ? escura : clara) ?? clara ?? '';
}

/** Decorativa por padrão (`alt=""`): o texto ao lado carrega o sentido. */
export function Ilustracao({ nome, tamanho = 120, className = '' }: { nome: NomeIlustracao; tamanho?: number; className?: string }) {
  const name = useNomeDoTema();
  return (
    <img
      className={`nv-ilustracao ${className}`.trim()}
      src={srcDaIlustracao(nome, name)}
      alt=""
      aria-hidden="true"
      width={tamanho}
      height={tamanho}
      draggable={false}
    />
  );
}
